import { Popover } from "@msuite/ui/popover";
import { guardString } from "@msuite/utils/strings";
import type { Nullable, NullableFields, Tables } from "@msuite/utils/types";
import { ContactPopover } from "@/components/popovers/contact-popover";

/** Props Interface */
interface ProjectClientProps {
	client: Nullable<NullableFields<Pick<Tables<"contacts">, "id" | "name">>>;
	fallback?: null | string;
}

export function ProjectClient({ client, fallback = null }: ProjectClientProps) {
	/** Guard */
	if (!client) return fallback;
	if (!client.name) return fallback;
	if (!client.id) return fallback;

	/** Render */
	return (
		<Popover
			render={() => <ContactPopover clientId={guardString(client?.id)} />}
			trigger="click"
		>
			<p className="hover:opacity-60 active:opacity-40 text-primaryGray-700 dark:text-primaryGray-200">
				{client.name}
			</p>
		</Popover>
	);
}
